(function(){
  const SEL='.pc-slideshow', ACTIVE='is-active';
  function start(c){
    if(c.__pcTimer) return;
    const slides=[...c.querySelectorAll('img.pc-slide')];
    if(slides.length<=1) return;
    let i=slides.findIndex(s=>s.classList.contains(ACTIVE));
    if(i<0){ i=0; slides[0].classList.add(ACTIVE); }
    const interval=parseInt(c.getAttribute('data-slide-interval'),10)||2500;
    const tick=()=>{ slides[i]?.classList.remove(ACTIVE); i=(i+1)%slides.length; slides[i]?.classList.add(ACTIVE); };
    const io=new IntersectionObserver(es=>es.forEach(e=>{
      if(e.isIntersecting){ if(!c.__pcTimer) c.__pcTimer=setInterval(tick,interval); }
      else{ clearInterval(c.__pcTimer); c.__pcTimer=null; }
    }),{threshold:0.2});
    io.observe(c);
    if(c.getBoundingClientRect().top < innerHeight) c.__pcTimer=setInterval(tick,interval);
  }
  function init(root=document){ root.querySelectorAll(SEL).forEach(start); }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>init()):init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:reorder',e=>init(e.target));
})();
